import { api } from 'utility';
import { getDeviceUrl, getDeleteDeviceUrl, getDeleteOtherDeviceUrl } from 'URLs';
// Cards
export function getDevices(params) {
  return api.get(getDeviceUrl(), { params }).then((res) => res.data);
}
export function deleteDevice(id) {
  return api.delete(getDeleteDeviceUrl(id)).then((res) => res.data);
}
export function deleteOtherDevice() {
  return api.delete(getDeleteOtherDeviceUrl()).then((res) => res.data);
}

export default {
  getDevices,
  deleteDevice,
  deleteOtherDevice,
};
